// Streamed Video Panel
//
// Plays when player achieves a big win

streamedVideoPanel = {};
streamedVideoPanel.videos = [];

streamedVideoPanel.createVideoPanel = function(json) {

    // Create texture that will stream
    var videoPanel = new PIXI.Container();
    streamedVideoPanel.videos.push(videoPanel);

    // Create associated sound
    if (typeof(json.soundFile) === "string") {
        videoPanel.sound = new Howl({urls: ["sounds/" + json.soundFile], loop: false});
    }

    videoPanel.startAnimation = function(completeCallback) {
        videoPanel.videoTexture = new PIXI.Texture.fromVideoUrl(ReflexLoader.rootResDir + json.fileName, PIXI.SCALE_MODES.LINEAR);
        videoPanel.videoTexture.baseTexture.source.Props = {};

        // Create a new video sprite
        this.videoSprite = new PIXI.Sprite(this.videoTexture);
        this.addChild(this.videoSprite);

        // Set callback properties
        this.videoTexture.baseTexture.source.Props.completeCallback = completeCallback;
        this.videoTexture.baseTexture.source.Props.videoPanel = this;

        // This is what happens when the video plays
        this.videoTexture.baseTexture.source.onplay = function() {
            var videoPanel = this.Props.videoPanel;

            if (typeof(this.Props.videoPanel.sound) !== "undefined") {
                this.Props.videoPanel.sound.play();
            }
        }

        // This is what happens when the video ends
        this.videoTexture.baseTexture.source.onended = function() {
            var videoPanel = this.Props.videoPanel;

            if (typeof(this.Props.completeCallback) === "function") {
                this.Props.completeCallback();
            }

            // Get rid of video sprite
            videoPanel.videoSprite.parent.removeChild(videoPanel.videoSprite);
            videoPanel.videoSprite = undefined;
            videoPanel.videoTexture = undefined;
        }
    }

    return videoPanel;

};
streamedVideoPanel.destroyVideoPanel = function(videoPanel) {
	var index = streamedVideoPanel.videos.indexOf(videoPanel);
    if (index === -1) {
        console.log("Could not destroy animation strip as it could not be found");
        return;
    }

    streamedVideoPanel.videos.splice(index, 1);
};

streamedVideoPanel.initialiseVideoPanel = function(json) {

};

resourceManager.registerObjectType("streamedVideoPanel", streamedVideoPanel.createVideoPanel, streamedVideoPanel.initialiseVideoPanel, function() { return []; }, streamedVideoPanel.destroyVideoPanel);